interface iPropsTotal {
    title: string,
    totalRegistros: string
}

export default function DespesasTotais({ title, totalRegistros }:iPropsTotal) {
    return (
        <div id="total_registros" style={{margin: "10px 10px 20px 0px"}}>
            <p className="total_title" style={{ textAlign: "left" }}>{title}</p>
            <p className="titleMain" style={{fontSize: "1.8em"}}>{totalRegistros}</p>
        </div>
    )
}